import React from 'react';
import PropTypes from 'prop-types';

const Duplicate = ({ color = '#8C949C', onClick = () => null }) => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
    >
        <defs>
            <path
                d="M8.96825397,0 C9.63888889,0 10,0.361111111 10,1.03174603 L10,6.19047619 C10,6.86111111 9.63888889,7.22222222 8.96825397,7.22222222 L3.80952381,7.22222222 C3.13888889,7.22222222 2.77777778,6.86111111 2.77777778,6.19047619 L2.77777778,1.03174603 C2.77777778,0.361111111 3.13888889,0 3.80952381,0 L8.96825397,0 Z M8.88888889,6.11111111 L8.88888889,1.11111111 L3.88888889,1.11111111 L3.88888889,6.11111111 L8.88888889,6.11111111 Z M2.22222222,3.33333333 L1.11111111,3.33333333 L1.11111111,8.88888889 L6.66666667,8.88888889 L6.66666667,7.77777778 L7.77777778,7.77777778 L7.77777778,9.13580247 C7.77777778,9.61111111 7.38888889,10 6.91358025,10 L0.864197531,10 C0.388888889,10 0,9.61111111 0,9.13580247 L0,3.08641975 C0,2.61111111 0.388888889,2.22222222 0.864197531,2.22222222 L2.22222222,2.22222222 L2.22222222,3.33333333 Z"
                id="duplicate-path-1"
            />
        </defs>
        <g
            id="Svg-Icons/10px-(All-icons)/no-scale/duplicate"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Svg-Icons/18px-(All-icons)/UI/duplicate-filled-18px">
                <g id="Fill/Primary/Default">
                    <mask id="duplicate-mask-2" fill="white">
                        <use xlinkHref="#duplicate-path-1" />
                    </mask>
                    <use
                        id="Combined-Shape"
                        fill={color}
                        fillRule="nonzero"
                        xlinkHref="#duplicate-path-1"
                    />
                    <g
                        id="Fill-Colors/Primary/Default"
                        mask="url(#duplicate-mask-2)"
                        fill={color}
                        className="icon-color"
                    >
                        <rect id="Rectangle-2" x="0" y="0" width="10" height="10" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

Duplicate.propTypes = {
    color: PropTypes.string,
    onClick: PropTypes.func,
};

export default Duplicate;
